import { Router } from '@angular/router';
var ActiveProductsComponent = /** @class */ (function () {
    function ActiveProductsComponent(router) {
        this.router = router;
        this.productos = [];
        this.loading = false;
        this.skeletonSlots = [0, 1, 2];
    }
    Object.defineProperty(ActiveProductsComponent.prototype, "items", {
        get: function () {
            return (this.productos || []).slice(0, 4);
        },
        enumerable: true,
        configurable: true
    });
    ActiveProductsComponent.prototype.irA = function (link) {
        this.router.navigate([link]);
    };
    ActiveProductsComponent.prototype.iconForProduct = function (p) {
        var base = 'resources/assets/images/main-page/';
        var key = ((p && p.branchType) || '').toLowerCase().trim();
        var fileMap = {
            legal: 'onlygal-abogado-365.svg',
            abogado: 'onlygal-abogado-365.svg',
            lawyer: 'onlygal-abogado-365.svg',
            travel: 'onlygal-asistencia-viaje.svg',
            viaje: 'onlygal-asistencia-viaje.svg',
            trip: 'onlygal-asistencia-viaje.svg',
            compraventa: 'onlygal-compraventa-asegurada.svg',
            home: 'onlygal-compraventa-asegurada.svg',
            vivienda: 'onlygal-compraventa-asegurada.svg',
            inmueble: 'onlygal-compraventa-asegurada.svg',
            car: 'car.svg',
            coche: 'car.svg',
            vehiculo: 'car.svg'
        };
        var file = 'bag-2.svg';
        for (var _i = 0, _a = Object.keys(fileMap); _i < _a.length; _i++) {
            var k = _a[_i];
            if (key.indexOf(k) !== -1) {
                file = fileMap[k];
                break;
            }
        }
        return base + file;
    };
    return ActiveProductsComponent;
}());
export { ActiveProductsComponent };
